import React, { createContext, useContext, useState } from 'react';

interface AuthUser {
  token: string;
  role: 'quant' | 'gsw_admin';
  full_name: string;
}

interface AuthContextType {
  user: AuthUser | null;
  login: (token: string, role: string, full_name: string) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<AuthUser | null>(() => {
    const stored = localStorage.getItem('gsw_auth');
    return stored ? JSON.parse(stored) : null;
  });

  const login = (token: string, role: string, full_name: string) => {
    const authUser = { token, role: role as AuthUser['role'], full_name };
    setUser(authUser);
    localStorage.setItem('gsw_auth', JSON.stringify(authUser));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem('gsw_auth');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
